// Interfaces
import { ILayoutPublicProps } from './interfaces'

const LayoutPublic = ({ children }: ILayoutPublicProps) => {
  return (
    <>
      <h1>Layout Public</h1>
      {children}
    </>
  )
}

export { LayoutPublic }
